import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './question.types';

export const questionSelectors = {
  ...generateResourceSelectors<types.IQuestion>((state) => state.resource.question),
};
